import { combineReducers } from 'redux';
import usersReducer from './data-slices/admin/userSlice';
import roleReducer from './data-slices/admin/roleSlice';
import complaintCaseReducer from './data-slices/admin/complaintCaseSlice';
import productSliceReducer from './data-slices/admin/productSlice';
import productMasterSliceReducer from './data-slices/admin/productMasterSlice';
import productTypesSliceReducer from './data-slices/admin/productTypesSlice';
import translationsSliceReducer from './data-slices/admin/tranlationsSlice';
import mailTemplatesSliceReducer from './data-slices/admin/mailTemplateSlice';
import keywordsSliceReducer from './data-slices/admin/keywordsSlice';
import menusSliceReducer from './data-slices/admin/menusSlice';
import helpCenterSliceReducer from './data-slices/admin/helpCenterSlice';
import subProductStepsSliceReducer from './data-slices/admin/subProductStepsSlice';
import customFieldsSliceReducer from './data-slices/admin/customFieldsSlice';
import flowBuilderSliceReducer from './data-slices/admin/flowBuilderSlice';
import publicSliceReducer from './data-slices/admin/publicSlice';
import bankMasterSliceReducer from './data-slices/admin/bankMasterSlice';
import bankContactSliceReducer from './data-slices/admin/bankContactSlice';
import apiSettingsSliceReducer from './data-slices/admin/apiSettingsSlice';
import paymentSubsSliceReducer from './data-slices/admin/paymentSubsSlice';
import promoCodesSliceReducer from './data-slices/admin/promoCodeSlice';
import accountsDetailsSliceReducer from './data-slices/admin/accountDetailsSlice';
import notificationsBunchesSliceReducer from './data-slices/admin/notificationsBunchesSlice';
import beneficiarySliceReducer from './data-slices/admin/beneficiarySlice';
import profileReducer from './data-slices/admin/profileSlice';
import partnerPayoutReducer from './data-slices/admin/misPayoutSlice';
import contactInquiryReducer from './data-slices/admin/contactInquirySlice';
import dynamicPagesSliceReducer from './data-slices/admin/dynamicPagesSlice';
import ipBlockListSliceReducer from './data-slices/admin/ipBlockSlice';
import caseContactsSliceReducer from './data-slices/admin/caseContactsSlice';

const admin = combineReducers({
    bankMasters: bankMasterSliceReducer,
    bankContact: bankContactSliceReducer,
    menus: menusSliceReducer,
    translations: translationsSliceReducer,
    users: usersReducer,
    customFields: customFieldsSliceReducer,
    roles: roleReducer,
    subProduct: productMasterSliceReducer,
    product: productSliceReducer,
    productTypes: productTypesSliceReducer,
    subProductSteps: subProductStepsSliceReducer,
    keywords: keywordsSliceReducer,
    complaintCase: complaintCaseReducer,
    mailTemplates: mailTemplatesSliceReducer,
    posts: helpCenterSliceReducer,
    flowBuilder: flowBuilderSliceReducer,
    public: publicSliceReducer,
    apiSettings: apiSettingsSliceReducer,
    paymentSubs: paymentSubsSliceReducer,
    promoCodes: promoCodesSliceReducer,
    accountsDetails: accountsDetailsSliceReducer,
    notificationsBunches: notificationsBunchesSliceReducer,
    beneficiary: beneficiarySliceReducer,
    profile: profileReducer,
    partnerPayout: partnerPayoutReducer,
    contactInquiry: contactInquiryReducer,
    pages: dynamicPagesSliceReducer,
    ipBlockList: ipBlockListSliceReducer,
    caseContacts: caseContactsSliceReducer,

})

export default admin;